<template>
  <loading :active="allPageLoading"
          :can-cancel="true"
          :on-cancel="onCancel"
          :is-full-page="true"
          :color="'#fff'"
          :background-color="'#000'"
          :opacity="'0.8'"
          :loader=" dots">
  </loading>
  <header class="top-bar">
    <div class="top-bar__left">
      <div class="breadcrumb">
        AutoTurn / <span>{{ title }}</span>
      </div>
    </div>

    <div v-if="$slots.default" class="top-bar__toolbar" :class="{ 'top-bar__toolbar--open': toolbarOpen }">
      <slot></slot>
    </div>

    <div class="top-bar__actions">
      <button v-if="$slots.default"
        @click="toolbarOpen = !toolbarOpen"
        class="top-bar__filter-btn"
        :class="{ 'top-bar__filter-btn--active': toolbarOpen }"
      >
        <i class="fas fa-sliders-h"></i>
      </button>
      <div class="relative">
        <button @click="notificationList"
          class="top-bar__icon-btn"
          :class="{'top-bar__icon-btn--active': notificationOpen}"
        >
          <i class="fas fa-bell"></i>
        </button>

        <div v-show="notificationOpen" @click="notificationList" class="fixed inset-0 h-full w-full z-10"
          style="display: none;"></div>

        <div v-show="notificationOpen"
          class="top-bar__dropdown"
          style="width: 20rem; display: none; overflow-y: auto; max-height: 160px;">
          <span v-if="infoList.length == 0 && notificationOpen == true" style="line-height:160px; width:20rem; text-align:center;display: block;">讀取中</span>
          <template v-for="(item, index) in infoList">
            <span class="top-bar__dropdown-item">
              <!-- <img class="h-8 w-8 rounded-full object-cover mx-1"
                src="http://placehold.it/100x100"
                alt="avatar"> -->
              <p class="text-sm mx-2">
                <!-- <span class="font-bold" href="#">Sara Salah</span> replied on the <span class="font-bold text-indigo-400"
                  href="#">Upload Image</span> artical . 2m -->
                <span class="font-bold">{{ item.info }}</span>
              </p>
            </span>
          </template>
          <!-- <a href="#" class="flex items-center px-4 py-3 text-gray-600 hover:bg-gray-100 -mx-2">
            <img class="h-8 w-8 rounded-full object-cover mx-1"
              src="http://placehold.it/100x100"
              alt="avatar">
            <p class="text-sm mx-2">
              <span class="font-bold" href="#">Slick Net</span> start following you . 45m
            </p>
          </a> -->
        </div>
      </div>

      <div class="relative">
        <button @click="dropdownOpen = ! dropdownOpen"
          class="top-bar__icon-btn"
          :class="{'top-bar__icon-btn--active': dropdownOpen}"
        >
          <i class="fas fa-globe"></i>
        </button>

        <div v-show="dropdownOpen" @click="dropdownOpen = false" class="fixed inset-0 h-full w-full z-10"
          style="display: none;"></div>

        <div v-show="dropdownOpen" class="top-bar__dropdown"
          style="display: none;">
          <a
            class="top-bar__dropdown-item"
            :class="langUsing == 'zh-TW' ? 'top-bar__dropdown-item--active' : null"
            @click="langUse('zh-TW', 1)">繁體中文</a>
          <a
            class="top-bar__dropdown-item"
            :class="langUsing == 'zh-CN' ? 'top-bar__dropdown-item--active' : null"
            @click="langUse('zh-CN', 1)">简体中文</a>
          <a
            class="top-bar__dropdown-item"
            :class="langUsing == 'en-US' ? 'top-bar__dropdown-item--active' : null"
            @click="langUse('en-US', 1)">English</a>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
  import { watch } from 'vue'
  import axios from 'axios'
  import Qs from 'qs'
  import Loading from 'vue3-loading-overlay';
  import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
  import "vue3-circle-progress/dist/circle-progress.css";

  export default {
    name: 'Header',
    components: {
      Loading
    },
    props: {
      title: {
        type: String,
        default: '帳號資訊'
      }
    },
    data() {
      return {
        allPageLoading: false,
        notificationOpen: false,
        dropdownOpen: false,
        toolbarOpen: false,
        infoList: [],
        langUsing: 'zh-TW'
      }
    },
    created() {
      // console.log(this.$route.params.id);
      // axios
      //   .post('https://www.autoturn.net/api/notification_system.php', Qs.stringify({
      //     s_code: this.$route.params.id
      //   }))
      //   .then((response) => {
      //     if(response.data.status == 'success'){
      //       this.infoList = response.data.return_data
      //     }
      //   });
      axios
        .post('https://www.autoturn.net/api/get_lang.php', Qs.stringify({
          s_code: this.$route.params.id
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.langUsing = response.data.return_data
            this.langUse(response.data.return_data);
          }
        });


    },
    watch:{
      '$route': function(){
        this.toolbarOpen = false;
      },
      'locale': function(v){
        // console.log('header:'+v);
        this.$emit('childLang', v);
      }
    },
    methods: {
      langUse(v, active){
        this.langUsing = v;
        this.$emit('childLang', v);

        axios
          .post('https://www.autoturn.net/api/data/lang_update.php', Qs.stringify({
            s_code: this.$route.params.id,
            lang: v
          }))
          .then((response) => {
            // if(response.data.status == 'success'){
              //console.log('response.data');
              //console.log(response.data);

              this.dropdownOpen = false;

              if(typeof active != 'undefined'){
                this.allPageLoading = true
                window.location.reload();
              }
            // }
          });


      },
      notificationList(){
        // console.log('notificationList');
        if(this.notificationOpen == false){
          //console.log('false');
          let type = this.$route.params.type;
          axios
            .post('https://www.autoturn.net/api/notification_system.php', Qs.stringify({
              s_code: this.$route.params.id,
              type: type
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.infoList = response.data.return_data

                this.notificationOpen = true;
              }
            });
        } else {
          // console.log('true');
          this.notificationOpen = false;
        }

      }
    }
  }
</script>
<style lang="">

</style>